import Vue from 'vue'
import {
  Sidebar, Table, Navbar, Icon, Modal,
} from 'buefy'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import router from './router'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Table)
Vue.use(Sidebar)
Vue.use(Navbar)
Vue.use(Icon)
Vue.use(Modal)
Vue.use(VueGtag, {
  config: { id: 'UA-119321074-4' },
})
Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
